import { FC } from 'react';
import { DesignObject, NodeType } from '../../types';
import { useDesign } from '../../hooks';
import { ItemDropdown, ItemDropdownPropsWithoutItems } from '../../form_components';
import { Case, convertCase } from '../../utilities';

export type ObjectDropdownProps = (
  {
    /** @see DesignObject._class to select. */
    type?: NodeType;
  }
  & ItemDropdownPropsWithoutItems<DesignObject, string>
);

/** Select a @see DesignObject from a @see Design. */
export const ObjectDropdown: FC<ObjectDropdownProps> = ({
  type,
  ...baseProps
}) => {
  const serialized = useDesign();
  const typeName = (!type) ? 'object' : convertCase(
    type.replace(/NodeModel$/, ''),
    Case.title
  ).toLocaleLowerCase();

  return (
    <ItemDropdown
      {...baseProps}
      items={serialized.components.objects.filter((object) => {
        return !type || object._class === type;
      })}
      labels={{
        noOptions: `No ${typeName}s in the design.`,
        placeholder: `Select ${typeName} from design.`,
        ...baseProps.labels
      }}
    />
  );
};
